/**
 * Class representing a user
 */
export class User {
  /**
   * Create a User.
   * @param {object} options - the user's  options to construct the user object with
   *        {string} options.firstName - user's first name
   * @param {String} options.firstName - the first name of the user
   * @param {String} options.surname - the last name of the user
   * @param {String} options.email - the email of the user
   * @param {String} options.phone - the phone number of the user
   * @param {String} options.phone2 - the 2nd phone number of the user
   * @param {String} options.fiscalCode - user's fiscal code
   */
  constructor (options) {
    if (options) {
      this.firstName = options.firstName
      this.surname = options.surname
      this.email = options.email
      this.phone = options.phone
      this.phone2 = options.phone2
      this.fiscalCode = options.fiscalCode
    }
  }

  get firstName () {
    return this._firstName
  }

  set firstName (value) {
    if (value) this._firstName = String(value)
    else this._firstName = null
  }

  get phone () {
    return this._phone
  }

  set phone (value) {
    if (value) this._phone = String(value)
    else this._phone = null
  }

  get phone2 () {
    return this._phone2
  }

  set phone2 (value) {
    if (value) this._phone2 = String(value)
    else this._phone2 = null
  }

  get fiscalCode () {
    return this._fiscalCode
  }

  set fiscalCode (value) {
    if (value) this._fiscalCode = String(value)
    else this._fiscalCode = null
  }

  get email () {
    return this._email
  }

  set email (value) {
    if (value) this._email = String(value)
    else this._email = null
  }
  get surname () {
    return this._surname
  }

  set surname (value) {
    if (value) this._surname = String(value)
    else this._surname = null
  }

  toJSON () {
    return {
      firstName: this._firstName,
      surname: this._surname,
      email: this._email,
      phone: this._phone,
      phone2: this._phone2,
      fiscalCode: this._fiscalCode
    }
  }
}
